module.exports = __webpack_public_path__ + "static/media/fieldtech.fa49c712.png";